module.exports = __webpack_public_path__ + "img/Icon-13.529efd30.svg";